<template>
  <component
    :is="component"
    v-if="component"
    v-bind="$attrs"
    :value="value"
    :filter="filter"
    v-on="$listeners"
  ></component>
</template>

<script>
const filterComponents = {
  properties: 'ProductListingFilterProperties',
  price: 'ProductListingFilterPrice',
  manufacturer: 'ProductListingFilterManufacturer',
}

export default {
  name: 'ProductListingFilterContainer',
  props: {
    value: {
      type: [String, Array],
      default: () => [],
    },
    filter: {
      type: Object,
      required: true,
    },
  },
  computed: {
    component() {
      if (
        !Object.prototype.hasOwnProperty.call(
          filterComponents,
          this.filter.code
        )
      ) {
        return null
      }

      return () => ({
        component: import(
          `@/components/product/listing/filter/${
            filterComponents[this.filter.code]
          }.vue`
        ),
      })
    },
  },
}
</script>
